// ThreeWickets Cricket Store - Cart System

class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = this.drawer?.querySelector('.cart-drawer-overlay');
    this.closeBtn = this.drawer?.querySelector('.cart-drawer-close');
    this.init();
  }

  init() {
    // Open drawer
    document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
      btn.addEventListener('click', () => this.open());
    });

    // Close drawer
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Quantity controls
    this.drawer?.addEventListener('click', (e) => {
      if (e.target.classList.contains('qty-plus')) {
        this.updateQuantity(e.target.dataset.key, 1);
      }
      if (e.target.classList.contains('qty-minus')) {
        this.updateQuantity(e.target.dataset.key, -1);
      }
      if (e.target.closest('.cart-item-remove')) {
        this.removeItem(e.target.closest('.cart-item-remove').dataset.key);
      }
    });

    // Quantity input change
    this.drawer?.addEventListener('change', (e) => {
      if (e.target.classList.contains('qty-input')) {
        const newQty = parseInt(e.target.value);
        if (newQty > 0) {
          this.setQuantity(e.target.dataset.key, newQty);
        }
      }
    });
  }

  open() {
    this.drawer?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer?.classList.remove('active');
    document.body.style.overflow = '';
  }

  async updateQuantity(key, change) {
    const input = this.drawer.querySelector(`.qty-input[data-key="${key}"]`);
    const currentQty = parseInt(input.value);
    const newQty = currentQty + change;
    if (newQty > 0) {
      await this.setQuantity(key, newQty);
    }
  }

  async setQuantity(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('Failed to update cart');
      const cart = await res.json();
      this.refreshDrawer();
    } catch (err) {
      console.error('Cart update error:', err);
      alert('Failed to update cart. Please try again.');
    }
  }

  async removeItem(key) {
    await this.setQuantity(key, 0);
  }

  async refreshDrawer() {
    try {
      const res = await fetch('/?section_id=header');
      if (!res.ok) throw new Error('Failed to fetch header section');
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newDrawer = doc.getElementById('cart-drawer');
      if (newDrawer) {
        this.drawer.innerHTML = newDrawer.innerHTML;
        this.overlay = this.drawer.querySelector('.cart-drawer-overlay');
        this.closeBtn = this.drawer.querySelector('.cart-drawer-close');
        this.init();
      }
      this.updateCartCount();
    } catch (err) {
      console.error('Refresh drawer error:', err);
      alert('Error refreshing cart. Please reload the page.');
    }
  }

  updateCartCount() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        document.querySelectorAll('#cart-count, .cart-drawer-count').forEach(el => {
          el.textContent = data.item_count;
        });
      });
  }
}

// Add to cart functionality
document.addEventListener('DOMContentLoaded', function () {
  window.cartDrawer = new CartDrawer();

  // Handle add to cart forms
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (res.ok) {
          await window.cartDrawer.refreshDrawer();
          window.cartDrawer.open();
          submitBtn.textContent = 'Added!';
          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        submitBtn.textContent = 'Error!';
        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    });
  });
});
